import { Parser } from "@siteimprove/alfa-parser";
import { Angle } from "../../../numeric/index.js";
import { Corner } from "./corner.js";
import { Side } from "./side.js";
const { either } = Parser;
/**
 * @internal
 */
export var Direction;
(function (Direction) {
    /**
     * @internal
     */
    Direction.parse = either(Angle.parse, 
    // Corners must be parsed before sides as sides are also valid prefixes of
    // corners.
    Corner.parse, Side.parse);
})(Direction || (Direction = {}));
//# sourceMappingURL=direction.js.map